export default function () {

  return function na(val = '') {
    return val || 'N/A';
  };
}



// WEBPACK FOOTER //
// ./src/filters/na.js